module.exports = __webpack_public_path__ + "assets/50e196212a82403996c7833b6d0a19fb.mp3";